package tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CurrentUser(
    @SerialName("id") val id: Int, // 54001
    @SerialName("name") val name: String, // You
    @SerialName("position") val position: Int, // 3
    @SerialName("waiting_time") val waitingTime: String // 21-28 min
)